import React from 'react';
import './video-player.css';
import '../mobile/video-player.css';

const VideoPlayer = ({video, playVideo}) => {
  return (
    <div className="video-player__container">
      <div className="video-player">
        <iframe
          frameBorder="0"
          height="100%"
          src={video}
          title="art_audio"
          width="100%"
          allow="autoplay"
          allowFullScreen
        />
      </div>
      {/* <div className="video-player__background" /> */}
    </div>
  );
};

export default VideoPlayer;

// <div style={ display ? { display: 'absolute' } : { display: 'none' } }>
